import * as React from 'react';

import { Link } from 'components/common/router';
import { Alert, Col, Row } from 'components/bootstrap';
import { IfPermitted } from 'components/common';
import useLicenseCheck from 'license/useLicenseCheck';
import Routes from 'routing/Routes';

const Status = () => (
  <Alert bsStyle="danger" title="Asset Events are disabled">
    <p>
      Asset Event definitions are disabled due to the absence of a valid Security license. It is still possible to
      create new or update any existing definitions, but new Alerts and Events will not be generated from them.
    </p>
    <IfPermitted permissions="licenses:create">
      <p>
        See <Link to={Routes.pluginRoute('SYSTEM_LICENSES')}>Licenses page</Link> for details.
      </p>
    </IfPermitted>
  </Alert>
);

type Props = {
  summary?: boolean;
  children?: React.ReactNode;
};

const EventsSecurityLicenseStatus = ({ summary = false, children = undefined }: Props) => {
  const {
    security: { isValid },
  } = useLicenseCheck();

  if (summary) return <Status />;

  return (
    <Row className="row-sm">
      <Col md={12}>{isValid ? children : <Status />}</Col>
    </Row>
  );
};

export default EventsSecurityLicenseStatus;
